export default __webpack_public_path__ + "decbdce871aa6d47636f2cefd8088923.png";